import AnimatedSection from '../../../components/base/AnimatedSection';

const comparisonData = [
  {
    label: 'Aylık Maliyet',
    expert: '₺45.000 - ₺75.000',
    expertDetail: 'maaş + vergi + yan hak',
    system: 'Sürdürülebilir ve düşük maliyet',
    systemDetail: 'Sabit aylık sistem bedeli',
    expertIcon: 'ri-money-dollar-circle-line',
    systemIcon: 'ri-discount-percent-line',
  },
  {
    label: 'Kurulum Süresi',
    expert: '3-6 ay',
    expertDetail: 'işe alım + adaptasyon',
    system: '2-4 hafta',
    systemDetail: 'Hızlı kurulum ve devreye alma',
    expertIcon: 'ri-calendar-line',
    systemIcon: 'ri-timer-flash-line',
  },
  {
    label: 'Ölçeklenebilirlik',
    expert: 'Ek personel = Ek maliyet',
    expertDetail: 'Her yeni otel için yeni eleman',
    system: 'Sınırsız ölçeklenme',
    systemDetail: 'Sistem büyüdükçe maliyet sabit',
    expertIcon: 'ri-user-add-line',
    systemIcon: 'ri-line-chart-line',
  },
  {
    label: 'Veri Erişimi',
    expert: 'Kişiye bağımlı',
    expertDetail: 'Excel ve manuel raporlar',
    system: 'Anlık dashboard',
    systemDetail: 'Rapor ekranları ile kolay takip',
    expertIcon: 'ri-user-line',
    systemIcon: 'ri-dashboard-line',
  },
  {
    label: 'Hata Riski',
    expert: 'İnsan faktörü yüksek',
    expertDetail: 'Manuel işlemler hata yapar',
    system: 'Otomasyon ile minimum',
    systemDetail: 'Yapay zeka destekli kontrol',
    expertIcon: 'ri-error-warning-line',
    systemIcon: 'ri-shield-check-line',
  },
  {
    label: 'Ayrılma Riski',
    expert: 'Bilgi kaybı, süreç duruşu',
    expertDetail: 'Yeni eleman bulma süreci',
    system: 'Süreklilik garanti',
    systemDetail: 'Sistem her zaman aktif',
    expertIcon: 'ri-user-unfollow-line',
    systemIcon: 'ri-loop-right-line',
  },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="relative py-24 bg-gradient-to-br from-gray-50 via-white to-gray-50 overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-10 w-96 h-96 bg-gold-200 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary/10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <AnimatedSection animation="fadeUp">
          <div className="text-center mb-20">
            <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-gold-100 to-gold-50 text-gold-700 rounded-full text-sm font-semibold mb-6 border border-gold-200 shadow-sm">
              <i className="ri-scales-3-line text-lg"></i>
              Karşılaştırma Tablosu
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 leading-tight">
              Neden Bir Uzman Daha İstihdam Etmek Yerine <br className="hidden md:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-500 via-gold-600 to-gold-500">
                Sistem Kurmalısınız?
              </span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Geleneksel uzman istihdamı ile modern sistem çözümlerini detaylı olarak karşılaştırın
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection animation="fadeUp" delay={100}>
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            {/* Header */}
            <div className="grid grid-cols-1 md:grid-cols-3 bg-gradient-to-r from-primary via-primary-dark to-primary text-white">
              <div className="p-8 border-b md:border-b-0 md:border-r border-white/10">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10">
                    <i className="ri-list-check text-xl"></i>
                  </div>
                  <span className="text-lg font-bold">Maliyet Kalemi</span>
                </div>
                <p className="text-white/60 text-sm">Detaylı karşılaştırma</p>
              </div>
              <div className="p-8 border-b md:border-b-0 md:border-r border-white/10 text-center bg-white/5">
                <div className="flex items-center justify-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10">
                    <i className="ri-user-star-line text-xl"></i>
                  </div>
                  <span className="text-lg font-bold">Uzman İstihdamı</span>
                </div>
                <p className="text-white/60 text-sm">Geleneksel yöntem</p>
              </div>
              <div className="p-8 text-center bg-gradient-to-r from-gold-500 to-gold-600 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
                <div className="relative z-10">
                  <div className="flex items-center justify-center gap-3 mb-2">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/20">
                      <i className="ri-cpu-line text-xl"></i>
                    </div>
                    <span className="text-lg font-bold">Prime Sales Pro</span>
                  </div>
                  <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-white/20 rounded-full text-xs font-semibold mt-1">
                    <i className="ri-star-fill text-sm"></i>
                    Önerilen Çözüm
                  </div>
                </div>
              </div>
            </div>

            {/* Rows */}
            {comparisonData.map((row, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 md:grid-cols-3 transition-all duration-300 hover:bg-gold-50/30 group ${
                  index % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'
                } ${index !== comparisonData.length - 1 ? 'border-b border-gray-100' : ''}`}
              >
                <div className="p-6 md:border-r border-gray-100 flex items-center border-b md:border-b-0">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-gold-500"></div>
                    <span className="font-bold text-primary text-base">{row.label}</span>
                  </div>
                </div>
                <div className="p-6 md:border-r border-gray-100 border-b md:border-b-0">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-100 text-gray-600 flex-shrink-0 group-hover:bg-gray-200 transition-colors duration-300">
                      <i className={`${row.expertIcon} text-xl`}></i>
                    </div>
                    <div>
                      <div className="text-gray-800 font-semibold text-base mb-1">{row.expert}</div>
                      <div className="text-gray-500 text-sm">{row.expertDetail}</div>
                    </div>
                  </div>
                </div>
                <div className="p-6 bg-gradient-to-r from-gold-50/50 to-gold-50/30 group-hover:from-gold-50 group-hover:to-gold-100/50 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-gold-100 to-gold-200 text-gold-700 flex-shrink-0 group-hover:scale-110 transition-transform duration-300 shadow-sm">
                      <i className={`${row.systemIcon} text-xl`}></i>
                    </div>
                    <div>
                      <div className="text-gray-900 font-bold text-base mb-1">{row.system}</div>
                      <div className="text-gray-600 text-sm">{row.systemDetail}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
